/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import MisconceptionCards, {
  MISCONCEPTION_CARD_ICONS,
} from '../../components/MisconceptionCards';
import SafeBrowsing from '../../components/SafeBrowsing';
import MisconceptionRiskCarousel from '../../components/MisconceptionRiskCarousel';
import NumberedStepsCarousel from '../../components/NumberedStepsCarousel';
import nscIllustration from '../../../../../../assets/student-training/pyde/img1.png';

import icon1 from '../../../../../../assets/student-training/pyde/avatar1.png';
import icon2 from '../../../../../../assets/student-training/pyde/avatar2.png';
import icon3 from '../../../../../../assets/student-training/pyde/avatar3.png';
import icon4 from '../../../../../../assets/student-training/pyde/avatar4.png';
interface ISection1Props {
  settings: any;
}

const iconMap: Record<number, string> = {
  1: icon1,
  2: icon2,
  3: icon3,
  4: icon4,
};

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-pyde-section1-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-1">
      <NumberedStepsCarousel
        type="image-left"
        mainTitle={paragraphsSettings?.section1MainTitle}
        subTitle={paragraphsSettings?.section1SubTitle}
        description={paragraphsSettings?.section1Description}
        illustration={<img src={nscIllustration} alt="" />}
        items={paragraphsSettings?.section1Item}
        defaultActive={0}
      />
      <MisconceptionCards
        subTitle={paragraphsSettings?.risksTitle}
        items={paragraphsSettings?.risks}
        tips={paragraphsSettings?.risksTips}
        icons={MISCONCEPTION_CARD_ICONS}
        id="student-training-pyde-section1-1"
        onComplete={handleMisconceptionCardsComplete}
      />

      <SafeBrowsing
        title={paragraphsSettings?.section3MainTitle}
        subTitle={''}
        description={paragraphsSettings?.section3Desc}
        sectionTitle={''}
        sectionDescription={''}
        slides={paragraphsSettings?.section3Items}
        icons={iconMap}
      />

      {/* <NumberedStepsCarousel
        type="simple"
        mainTitle="安全下載的最佳實踐"
        description="下載應用程式或檔案時，應從可信來源取得，並留意授權條款與權限要求。"
        items={NSC_ITEMS}
        defaultActive={0}
      />
      <NumberedStepsCarousel
        type="case-study"
        caseLabel="案例研究"
        caseTitle="網上學習平台事件的教訓"
        description="從本案例研究中，我們可以總結出以下幾個重要教訓，幫助你在日常生活中更好地保護個人資料。"
        items={NSC_ITEMS}
        defaultActive={0}
      />
      <NumberedStepsCarousel
        type="image-left"
        mainTitle="甚麼屬於個人
            description:
              '部分網站會透過彈窗、下載或更新提示，誘使用戶安裝惡意程式，感染裝置。',
          },
          {
            id: 3,
            title: '影響共用帳戶',
            description: '如共用郵箱或系統帳戶中招，影響範圍可能更大。',
          },
          {
            id: 4,
            title: '盜取登入資料',
            description: '假網站可騙取公司電郵、雲端平台或業務系統帳戶資料。',
          },
        ]}
        icons={iconMap}
      />

      {/* <NumberedStepsCarousel
        type="simple"
        mainTitle="安全下載的最佳實踐"
        description="下載應用程式或檔案時，應從可信來源取得，並留意授權條款與權限要求。"
        items={NSC_ITEMS}
        defaultActive={0}
      />
      <NumberedStepsCarousel
        type="case-study"
        caseLabel="案例研究"
        caseTitle="網上學習平台事件的教訓"
        description="從本案例研究中，我們可以總結出以下幾個重要教訓，幫助你在日常生活中更好地保護個人資料。"
        items={NSC_ITEMS}
        defaultActive={0}
      />
      <NumberedStepsCarousel
        type="image-left"
        mainTitle="甚麼屬於個人資料"
        description="個人資料不一定只限於姓名和身份證號碼，任何能識別你身份的資訊都屬於個人資料。"
        illustration={<img src={nscIllustration} alt="" />}
        items={NSC_ITEMS}
        defaultActive={0}
      /> */}
      {/* <MisconceptionRiskCarousel
        id="student-training-ics-section1-2"
        title={paragraphsSettings?.l1RightListTitle}
        tips={paragraphsSettings?.l1RightListDesc}
        items={paragraphsSettings?.l1RightList}
      /> */}
    </div>
  );
};

export default Section1;
